/**
 * Visible label for DEMO data: the parent Learning Insight preview (Slice 1)
 * and the sample school materials (Slice 2). Shown only in local/development
 * builds (decision D-02); never on real learner data.
 */
export function DemoBadge(): React.JSX.Element {
  return (
    <span className="rounded-md bg-fuchsia-100 px-2 py-0.5 text-base font-bold tracking-wide text-fuchsia-900 dark:bg-fuchsia-950 dark:text-fuchsia-200">
      DEMO
    </span>
  )
}
